import React from 'react';
import { Box, IconButton, Typography, Badge, AppBar, Toolbar } from '@mui/material';
import { Menu, Notifications, ExitToApp } from '@mui/icons-material';
import { useMediaQuery } from '@mui/material';

// Importing the logo image
import logo from '../assets/images/logo.png'; // Adjust the path as necessary

const TopNav = ({ onLogout, onNotificationClick, toggleSidebar }) => {
  const isMobile = useMediaQuery('(max-width:768px)');

  // Fetching the user profile from localStorage
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  // Get username from the profile (assuming it's stored under "first_name")
  const username = userProfile ? userProfile.hospital_name : "User";

  return (
    <AppBar position="sticky" color="primary" elevation={3} sx={{ top: 0 }}>
      <Toolbar sx={{ justifyContent: 'space-between', minHeight: '48px' }}>
        {/* Mobile Sidebar Toggle Icon */}
        {isMobile && (
          <IconButton color="inherit" onClick={toggleSidebar}>
            <Menu />
          </IconButton>
        )}

        {/* Logo and Company Name */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={logo} // Using imported logo
            alt="Logo"
            style={{ width: 40, height: 40, marginRight: 10 }}
          />
          <Typography variant="h6" sx={{ color: 'white' }}>
            Welcome, {username} Admin
          </Typography>
        </Box>

        {/* Notification and Logout Icons */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {/* Notifications Icon with Badge */}
          <IconButton color="inherit" onClick={onNotificationClick}>
            <Badge badgeContent={4} color="error">
              <Notifications />
            </Badge>
          </IconButton>

          {/* Logout Icon */}
          <IconButton color="inherit" onClick={onLogout}>
            <ExitToApp />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopNav;
